const Contact = () => {
  return (
    <div className="max-w-3xl mx-auto py-16 px-6">
      <h1 className="text-3xl font-bold mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
        Contact Us
      </h1>
      <p className="text-gray-600 mb-8">
        Have questions about our 3D map art? We would love to hear from you.
      </p>
      <div className="space-y-4">
        <p className="text-gray-600">
          Email: <a href="mailto:hello@geoforge3d.com" className="underline">hello@geoforge3d.com</a>
        </p>
      </div>
    </div>
  );
};

export default Contact;
